/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../../store";
import editLogo from "../../CreateTenant/EditLogo.png";

import { ConfigurationVariables } from "../../../config";
import TextInputField from "../../../utils/text-input-field/TextInputField";
import AcceptTerms from "../../../utils/accept-terms/AcceptTerms";
import ConfirmModal from "../../../utils/modals/confirm-modal/ConfirmModal";
import InfoModal from "../../../utils/modals/info-modal/InfoModal";
import Loader from "../../Loader/Loader";
import UploadProfilePic from "../../../utils/upload-profile-pic/UploadProfilePic";
import useFetch from "../../../hooks/useFetch";
import { IErrorProps } from "../../../models";
import ToastBarForError from "../../SharedComponents/ToastBarForError";
import { getAccessToken } from "../../../utils";
import "./CreateOrganisation.scss";
import CreateOrganisationFooter from "./Footer";
import { TreeSelect } from "primereact/treeselect";
import OrganizationHDTOKey from "../../../models/apiModels/OrganizationHDTOKey";
import OrganizationDTO from "../../../models/apiModels/OrganizationDTO";
import { useSelector, useDispatch } from "react-redux";
import {
  createOrganizationbyID,
  uploadOrgLogoDetails,
} from "../../../store/Organisation/organisation-actions";
import getAllParentKeys from "../../../utils/methods/getAllParentKeys";
import { organizationActions } from "../../../store/Organization/organization-slice";
import TreeTableOrganizationData from "../../../models/apiModels/TreeTableOrganizationData";
import GetOrgbyKey from "../../../utils/methods/GetOrgbyKey";
import { truncate } from "fs";
import BreadCrumbsComponent from "../../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../../SharedComponents/Title/Title";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Label,
  Chip,
  ChipRemove,
  ControlError,
} from "@forge/common";
import { UUID } from "../../../models/apiModels/Organization";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import updateErrorList from "../../../utils/methods/updateErrorList";
import DefaultProfileImg from "../../../images/addLogo.png";
import DefaultProfileImgDark from "../../../images/DefaultProfileImgDark.png";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";
import { normalizeOrganizationGroupId } from "../../../utils/methods/normalizeOrganizationGroupId";

const ORGANISATION_CRUMB_ID = "Organisation";

function CreateOrganisation() {
  const theme = useSelector((state: any) => state?.theme?.currentTheme);
  const {
    TenantMgmt_Endpoints,
    UserMgmt_Endpoints,
    Api,
    Version,
    UserController,
  } = ConfigurationVariables;
  let usersUrl = `${UserMgmt_Endpoints}/${Api}/${Version}/${UserController}`;
  const createNewOrgUrl = `${TenantMgmt_Endpoints}/${Api}/${Version}/organization`;
  const config = {
    headers: {
      accept: "application/json",
      customerId: "honeywell",
      Authorization: `Bearer ${getAccessToken()}`,
    },
  };
  const [t] = useTranslation();
  const [crumbs, setCrumbs] = useState([
    {
      id: ORGANISATION_CRUMB_ID,
      label: t(localeKeyMap.organization),
    },
    {
      id: "CreateOrganisation",
      label: "Create Organization",
    },
  ]);
  const navigate = useNavigate();
  const location = useLocation();
  const tenantId = location?.state?.tenantId;

  const dispatch: AppDispatch = useDispatch();

  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );
  const organizationOriginalDataTree: TreeTableOrganizationData[] =
    useSelector((state: RootState) => state.organisation.treeTableOrganization);
  const [orgName, setOrgName] = useState("");
  const [orgId, setOrgId] = useState("");
  const [isOrgIdDirty, setIsOrgIdDirty] = useState<boolean>(false);
  const [isOrgNameEmpty, setIsOrgNameEmpty] = useState<boolean>(false);
  const [isOrgNameValid, setIsOrgNameValid] = useState<boolean>(true);
  const [isParentValid, setIsParentValid] = useState<boolean>(true);
  const [parentOrgName, setParentOrgName] = useState("");
  // const [parentOrgId, setParentOrgId] = useState("");
  const [isParentOrgEmpty, setIsParentOrgEmpty] = useState<boolean>(false);
  const [orgProfilePic, setOrgProfilePic] = useState<File>();
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);

  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const orgNameRegex = /^[a-zA-Z0-9\s]*$/;
  const [selectedNodeKey, setSelectedNodeKey] = useState<any>([]);

  const cancelBtnHandler = () => {
    setConfirmModal(false);
    navigate(-1);
  };

  /**
   * To display helper text
   * Setting true  in state if any field is empty
   */
  const checkFieldEmpty = () => {
    !orgName && setIsOrgNameEmpty(true);
    !selectedNodeKey?.length && setIsParentValid(false);
  };

  /**
   * Checks if the organisation name, parent org fields input entered
   * @returns boolean - returns fasle if any field is missing
   */
  const hasAllFieldsInput = () => {
    if (orgName && selectedNodeKey?.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * @summery
   * input fields validation: empty field check
   * opens confirm model if all mandatory fields entered and valid
   */
  const createBtnHandler = () => {
    //on click create
    checkFieldEmpty();
    if (hasAllFieldsInput() && !isTermsAccepted) {
      setIsFormFilled(true);
      setIsTermsAccepted(false);
    }

    // checking if all mandatory fields are filled and open confirm modal
    if (hasAllFieldsInput() && isOrgNameValid && isTermsAccepted) {
      setConfirmModal(true);
    }
    if (hasAllFieldsInput() && parentOrgName && isTermsAccepted) {
      setConfirmModal(true);
    }
  };

  const getOrgNameHelperText = () => {
    let helperText = "";
    if (isOrgNameEmpty) {
      helperText = t(localeKeyMap.pleaseEnterValidName);
    }
    if (!isOrgNameEmpty && !isOrgNameValid) {
      helperText = t(localeKeyMap.organizationNameAlphanumeric);
    }
    return helperText;
  };

  /**
   *
   * Saving organisation in database on click confirm create btn
   */
  // istanbul ignore next
  // This gets called from Confirm Modal
  const confirmCreateHandler = () => {
    setConfirmModal(false);
    setIsLoading(true);
    setErrorListGlobal([]);
    const ParentId = GetOrgbyKey(selectedNodeKey, organizationOriginalDataTree)
      ?.data?.organizationId;
    let reqBody = {
      organizationName: orgName,
      groupId: orgId,
      organizationId: orgId,
      parentOrganizationId: ParentId,
      tenantId: tenantId,
      version: 0,
    };
    /**Creating new user in data base */
    dispatch(createOrganizationbyID(reqBody))
      .unwrap()
      .then((response) => {
        let organizationId = response.id;
        const parameter: any = {
          organizationId: organizationId,
          tenantId: tenantId,
          fileName: orgProfilePic,
        };

        if (orgProfilePic) {
          // @TODO: Implement once api is ready
          setIsLoading(true);
          dispatch(uploadOrgLogoDetails(parameter))
            .unwrap()
            .then(() => {
              // Set Success Modal to true if profile pic is uploaded
              setSuccessModal(true);
            })
            .catch((error) => {
              setErrorListGlobal((prevState) =>
                updateErrorList(error, [...prevState])
              );
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
        // Set Success Modal to true if no profile pic
        else {
          setSuccessModal(true);
        }
      })
      .catch((error) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClickChip = () => {
    setParentOrgName("");
    setSelectedNodeKey([]);
    setIsParentValid(false);
  };

  useEffect(() => {
    const ParentId: string = GetOrgbyKey(
      selectedNodeKey,
      organizationOriginalDataTree
    )?.data?.organizationId;

    // setParentOrgId(ParentId);

    setParentOrgName(
      GetOrgbyKey(selectedNodeKey, organizationOriginalDataTree)?.data?.name
    );
  }, [selectedNodeKey]);

  /**
   * To close toast bar
   */

  /**
   * To set selected parent org in state
   * @param event
   * @param nodeId selected nodeId
   */
  // const onParentOrgSelect = (event: any, nodeId: any | string) => {
  //   setParentOrgId(nodeId);
  //   setParentOrgName(event.target.innerText);
  //   setIsParentOrgEmpty(false);
  // };

  // const handleDelete = () => {
  //   setParentOrgId("");
  //   setParentOrgName("");
  //   setIsParentOrgEmpty(true);
  // };

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////
  const backButtonHandler = () => {
    navigate(-1);
  };

  const handleCrumbClick = (crumb: { id: string; href?: string }) => {
    if (crumb.id === ORGANISATION_CRUMB_ID) {
      navigate("/organization");
    }
  };
  return (
    <>
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={backButtonHandler}
        onCrumbClick={handleCrumbClick}
      />
      <Title
        title={t(localeKeyMap.createNewOrganization)}
        className="p-t15"
        buttonRequired={false}
      />
      <Card className="create_user p-b5">
        <React.Fragment key=".0">
          <CardHeader
            title={t(localeKeyMap.organizationProfile)}
            className="sub-header p-20"
          />
          <CardContent className="d-flex main_form_wrap p-20">
            {/* <div className="form_logo_wrap text-center"> */}
            <UploadProfilePic
              labelText={t(localeKeyMap.addLogo)}
              profilePic={
                theme === "light" ? DefaultProfileImg : DefaultProfileImgDark
              }
              onImageUpload={(image) => {
                setOrgProfilePic(image);
              }}
              isUploadDisabled={false} //@TODO: Enable once api is ready
            />
            <div className="form_box" style={{ justifyContent: "unset" }}>
              <h4>{t(localeKeyMap.basicInformation)}</h4>
              <div className="form_col p-10">
                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.organizationName)}
                    id="OrgName"
                    type="text"
                    required={true}
                    styleName="text-input-field"
                    placeholder={t(localeKeyMap.organizationName)}
                    value={orgName ?? ""}
                    onChange={(value) => {
                      setOrgName(value);
                      if (!isOrgIdDirty) {
                        setOrgId(normalizeOrganizationGroupId(value));
                      }
                      setIsOrgNameEmpty(false);
                      orgNameRegex.test(value)
                        ? setIsOrgNameValid(true)
                        : setIsOrgNameValid(false);
                    }}
                    error={isOrgNameEmpty || !isOrgNameValid}
                    helperText={getOrgNameHelperText()}
                    dataTestId="orgName"
                  />
                </div>
                <div className="form_col m-t10">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.organizationId)}
                    id="OrgId"
                    type="text"
                    required={false}
                    styleName="text-input-field"
                    placeholder={t(localeKeyMap.organizationId)}
                    value={orgId ?? ""}
                    onChange={(value) => {
                      setIsOrgIdDirty(true);
                      setOrgId(normalizeOrganizationGroupId(value));
                    }}
                    dataTestId="orgId"
                  />
                </div>
                <div className="form_col m-t10">
                  <Label requiredText="*"> {t(localeKeyMap.parentOrganizationName)} *</Label>
                  <TreeSelect
                    value={selectedNodeKey}
                    className={
                      isParentValid
                        ? "dropdown_tree"
                        : "dropdown_tree p-invalid"
                    }
                    filter
                    onChange={(e) => {
                      const setKeys = e?.value;
                      setIsParentValid(setKeys === null ? false : true);

                      setSelectedNodeKey(setKeys);
                      setIsParentValid(setKeys === null ? false : true);
                    }}
                    options={hierarchicalOrganizationwKey}
                    metaKeySelection={false}
                    selectionMode="single"
                    placeholder={t(localeKeyMap.selectParentOrganization)}
                    style={{
                      width: "100%",
                    }}
                    data-testid="SelectParentOrganisation"
                  ></TreeSelect>

                  {isOrgNameEmpty &&
                    (parentOrgName === undefined || parentOrgName === "") && (
                      <ControlError className="control-error">
                        {t(localeKeyMap.selectValidParentOrganization)}
                      </ControlError>
                    )}
                  {parentOrgName && (
                    <Chip className="theme-chip">
                      {parentOrgName}
                      <ChipRemove
                        onClick={() => handleClickChip()}
                        className="theme-chip-remove"
                      >
                        {parentOrgName}
                      </ChipRemove>
                    </Chip>
                  )}
                </div>
              </div>
            </div>
          </CardContent>
        </React.Fragment>
      </Card>
      <div className="create_user p-b15 m-t10">
        <AcceptTerms
          text={t(localeKeyMap.acceptCreateOrganization)}
          isFormFilled={isFormFilled}
          isTermsAccepted={isTermsAccepted}
          onTermsAccept={(event) => {
            setIsTermsAccepted(event?.target.checked);
          }}
        />
      </div>
      {/* <EditOrganisationFooter
        cancelBtnHandler={cancelBtnHandler}
        createBtnHandler={updateBtnHandler}
      /> */}
      <Card className="footer">
        <Button
          onClick={cancelBtnHandler}
          variant="quiet-primary"
          data-testid="CancelOrgButton"
        >
          {t(localeKeyMap.cancel)}
        </Button>
        <Button
          size="regular"
          variant="primary"
          className="cursor-pointer"
          data-testid="CreateOrgButton"
          onClick={createBtnHandler}
        >
          {t(localeKeyMap.create)}
        </Button>
        <ConfirmModal
          dialogTitle={t(localeKeyMap.createNewOrganization)}
          dialogContentText={t(localeKeyMap.confirmCreateOrganization)}
          onConfirmClick={confirmCreateHandler}
          onCancelClick={() => setConfirmModal(false)}
          onCloseClick={() => setConfirmModal(false)}
          open={confirmModal}
          primaryBtnText={t(localeKeyMap.create)}
        />
        <InfoModal
          dialogTitle={t(localeKeyMap.successfullyCreated)}
          dialogContentText={t(localeKeyMap.organizationCreated)}
          onOkClick={() => {
            setSuccessModal(false);
            navigate(`/organization?refreshAfterCreate=true&orgName=${encodeURIComponent(orgName)}`);
          }}
          open={successModal}
        />
      </Card>
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
    </>
  );
}

export default CreateOrganisation;